module.exports = __webpack_public_path__ + "img/sixpackcarrier67.233335b1.jpg";